import React, { useContext, useState, useRef, memo } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../../Context";
import { ShowContext } from "../../ModalContext";
import uniqid from "uniqid";
import Modal from "../Modal/Modal";
import "./LibraryBook.css";
import amazon from "../../assets/amazon-logo.svg";
import sound from "../../assets/sound.svg";
import { getLibrivoxLink } from "../../helpers/getData";
import { div } from "framer-motion/client";
import { AnimatePresence, motion } from "framer-motion";

const customStyles = {
  content: {
    width: "70vw",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const LibraryBook = memo((props) => {
  console.log("newBook");
  const location = useLocation();
  const { data, setData } = useContext(Context);
  const { showData, setShowData } = useContext(ShowContext);
  const [showDescription, setShowDescription] = useState(false);
  const img = props.book.img;

  const title = props.book.title;
  const ISBN = props.book.ISBN;
  const buyLink = `https://www.amazon.com/dp/${props.book.amazon}`;
  const viewerRef = useRef(null);
  const loadScript = async (scriptUrl) => {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${scriptUrl}"]`)) {
        console.log("Script already loaded");
        resolve();
        return;
      }
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.onload = () => {
        console.log("Google Books script loaded.");
        resolve();
      };
      script.onerror = () => {
        console.error("Failed to load Google Books script.");
        reject(new Error("Failed to load script"));
      };
      document.body.appendChild(script);
    });
  };

  const initializeGoogleBooksViewer = () => {
    const viewerCanvas = document.getElementById("viewerCanvas");
    const notFound = () => {
      alert("Preview not available.");
      viewerCanvas.style.display = "none";
    };
    if (window.google && window.google.books && viewerCanvas) {
      console.log("Initializing Google Books Viewer");
      console.log("ISBN________________", props.book.ISBN);
      try {
        viewerRef.current = new window.google.books.DefaultViewer(viewerCanvas);
        console.log(window.google.books);
        setTimeout(() => {
          viewerRef.current.load(`${props.book.ISBN}`, notFound);
          //viewerRef.current.load(9781072774693, notFound);
        }, 2000);
      } catch (error) {
        console.error("Error initializing Google Books Viewer:", error);
      }
    } else {
      console.error(
        "Google Books API not fully loaded or viewerCanvas not found.",
      );
    }
  };

  const setupViewer = async () => {
    console.log("setupviewer");
    try {
      await loadScript("https://www.google.com/books/jsapi.js");
      if (window.google && window.google.books) {
        window.google.books.load();
        window.google.books.setOnLoadCallback(initializeGoogleBooksViewer);
      }
    } catch (error) {
      console.error("Error loading or initializing Google Books API", error);
    }
  };

  const openPreview = () => {
    console.log("Opening book preview modal");
    setShowData({ show: true, selectedBookId: ISBN });
    console.log(props.book.ISBN);
    if (props.book.ISBN) {
      try {
        setupViewer();
        setTimeout(() => {
          initializeGoogleBooksViewer();
        }, 1000);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const openDescription = () => {
    setShowDescription(true);
  };

  const close = () => {
    console.log("Closing book preview modal");
    setShowDescription(false);
    setShowData(false);
  };

  return (
    <AnimatePresence initial={true}>
      <div>
        {showData.show &&
          location.pathname == "/library" &&
          showData.selectedBookId === ISBN && (
            <Modal
              show={showData.show}
              handleClose={close}
              style={customStyles}
            >
              <div
                id="viewerCanvas"
                style={{ width: "100%", height: "100%", zIndex: 4000 }}
              ></div>
            </Modal>
          )}

        <Modal show={showDescription} handleClose={close}>
          <div
            className="google-viewer"
            style={{ margin: "0 auto", paddingTop: "3em", width: "90%" }}
          >
            {props.book.description}
          </div>
        </Modal>

        <ul className="card-wrapper">
          <div className="buttons">
            <button className="library-button" onClick={openDescription}>
              ?
            </button>

            {/* amazon button for best and best by date */}
            {props.book.amazon && location.pathname != "/library" && (
              <button className="library-button amazon">
                <a href={props.book.amazon} target="_blank">
                  <img className="amazon" src={amazon} alt="amazon link" />
                </a>
              </button>
            )}
            {/* amazon button for library */}
            {props.book.amazon && location.pathname == "/library" && (
              <button className="library-button amazon">
                <a href={buyLink} target="_blank">
                  <img className="amazon" src={amazon} alt="amazon link" />
                </a>
              </button>
            )}
            {props.book.librivox && (
              <button className="library-button">
                <a href={props.book.librivox} target="_blank">
                  <img className="sound" src={sound} alt="audio book" />
                </a>
              </button>
            )}
          </div>

          {location.pathname == "/library" && (
            <button className="library-button" onClick={openPreview}>
              Preview
            </button>
          )}

          <motion.li
            layout
            location={location}
            key={location.pathname}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.5,
              scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
            }}
            
            className="library-book"
          >
            <img
              src={img}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = { img };
              }}
              // loading="lazy"
              alt="book cover"
              key={uniqid()}
              className="library-book-cover"
            ></img>
          </motion.li>
        </ul>
      </div>
    </AnimatePresence>
  );
});

export default LibraryBook;
